import React, { useEffect, useState, useCallback } from 'react';
import { Container, Description, Button } from './styles';

const serviceConfigs = {
  proof: {
    buttonText: name => 'Baixar fotos',
    description: (seconds, name) => (
      <>
        Em <strong>00:{seconds.toString().padStart(2, '0')}</strong> segundos
        você será redirecionado para baixar as fotos compradas.
      </>
    ),
  },
  default: {
    buttonText: name => `Voltar para ${name}`,
    description: (seconds, name) => (
      <>
        Em <strong>00:{seconds.toString().padStart(2, '0')}</strong> segundos
        você será redirecionado para {name}.
      </>
    ),
  },
};

export default function RedirectCronometer({ linkTo, name, service }) {
  const [seconds, setSeconds] = useState(59);

  const redirect = useCallback(() => {
    window.location.href = linkTo;
  }, [linkTo]);

  useEffect(() => {
    if ((!service && !name) || !linkTo) return;

    const timer = setInterval(() => {
      setSeconds(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          redirect();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [redirect]);

  if ((!service && !name) || !linkTo) return null;

  const { description, buttonText } =
    service && serviceConfigs[service]
      ? serviceConfigs[service]
      : serviceConfigs.default;

  return (
    <Container>
      <Description>{description(seconds, name)}</Description>
      <Button onClick={redirect}>{buttonText(name)}</Button>
    </Container>
  );
}
